import React from 'react'
import styled from 'styled-components'
import { media } from '../../../styles/media'
import PlayButtonIcon from '../../icons/PlayButton'

export const Wrapper = styled.button`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 80px;
  height: 80px;
  padding: 0;
  appearance: none;
  border: none;
  background: transparent;

  transform: translate(-50%, -50%);
  z-index: 2;

  svg {
    height: 100%;
    width: 100%;
  }

  ${media.md`
    height: 100px;
    width: 100px;
  `}
`

const PlayButton = (props) => (
  <Wrapper {...props} aria-label="Play video">
    <PlayButtonIcon />
  </Wrapper>
)

export default PlayButton
